// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/fulfillment/cash_on_delivery_settlement/v1/cash_on_delivery_settlement.proto (package stailer_service_specification.fulfillment.cash_on_delivery_settlement.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");

/**
 * Describes the file stailer_service_specification/fulfillment/cash_on_delivery_settlement/v1/cash_on_delivery_settlement.proto.
 */
const file_stailer_service_specification_fulfillment_cash_on_delivery_settlement_v1_cash_on_delivery_settlement = /*@__PURE__*/
  fileDesc("CmpzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9mdWxmaWxsbWVudC9jYXNoX29uX2RlbGl2ZXJ5X3NldHRsZW1lbnQvdjEvY2FzaF9vbl9kZWxpdmVyeV9zZXR0bGVtZW50LnByb3RvEkhzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5mdWxmaWxsbWVudC5jYXNoX29uX2RlbGl2ZXJ5X3NldHRsZW1lbnQudjEiGgoYQ2FzaE9uRGVsaXZlcnlTZXR0bGVtZW50YgZwcm90bzM");

/**
 * Describes the message stailer_service_specification.fulfillment.cash_on_delivery_settlement.v1.CashOnDeliverySettlement.
 * Use `create(CashOnDeliverySettlementSchema)` to create a new message.
 */
const CashOnDeliverySettlementSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_fulfillment_cash_on_delivery_settlement_v1_cash_on_delivery_settlement, 0);


exports.file_stailer_service_specification_fulfillment_cash_on_delivery_settlement_v1_cash_on_delivery_settlement = file_stailer_service_specification_fulfillment_cash_on_delivery_settlement_v1_cash_on_delivery_settlement;
exports.CashOnDeliverySettlementSchema = CashOnDeliverySettlementSchema;
